/* Homepage hero experiment. No customer identity or order data enters the browser tracker. */
(function (window, document) {
  'use strict';
  var configNode = document.getElementById('pvl-hero-experiment-config');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var query = new URLSearchParams(window.location.search);
  // Live validation has its own experiment ID and never enters a production cohort.
  var validationVariant = !config.preview && /^[ABC]$/.test(query.get('pvl_hero_validate') || '') ? query.get('pvl_hero_validate') : null;
  if (validationVariant) config.id += '_qa';
  var KEY = 'pvl_' + config.id, STAFF = 'pvl_hero_staff', DAY = 86400000;
  // Live arms. A dropped arm stays renderable (QA overrides, player-load fallback) but is never
  // drawn for new visitors, and browsers already enrolled in it stop counting (arm A dropped Oct 15, 2026).
  var ARMS = (Array.isArray(config.arms) ? config.arms : ['A','B','C']).filter(function (v) { return /^[ABC]$/.test(v); });
  if (!ARMS.length) ARMS = ['A','B','C'];
  var forced = query.get('pvl_hero');
  if (!/^[ABC]$/.test(forced || '')) forced = null;
  var staff = !!config.staff, automated = false;
  try {
    if (query.get('pvl_hero_staff') === '1') window.localStorage.setItem(STAFF, '1');
    if (query.get('pvl_hero_staff') === '0') window.localStorage.removeItem(STAFF);
    staff = staff || window.localStorage.getItem(STAFF) === '1';
  } catch (_) {}
  try { automated = navigator.webdriver === true || Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Singapore' || /bot|crawler|spider|headless|lighthouse|page ?speed|ptst|gtmetrix/i.test(navigator.userAgent); } catch (_) {}
  var state = { variant: forced || ARMS[0], eligible: false, reason: 'initializing', record: null };
  var qa = !!forced || !!validationVariant || query.has('pvl_hero_staff') || !!config.preview;
  var readyResolve;
  var ready = new Promise(function (resolve) { readyResolve = resolve; });
  var settled = false, currentSection = null, timer = 0, active = false, activeAt = 0, pendingMs = 0;
  var mounted = new WeakSet(), players = {}, eventLog = [], consentRevoked = false;
  function consentAllowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function randomVariant() {
    var value = new Uint32Array(1);
    window.crypto.getRandomValues(value);
    return ARMS[Math.floor(value[0] / 4294967296 * ARMS.length)];
  }
  function subjectId() {
    if (window.crypto.randomUUID) return window.crypto.randomUUID();
    var values = new Uint32Array(4); window.crypto.getRandomValues(values);
    return Array.from(values).map(function (n) { return n.toString(16).padStart(8,'0'); }).join('');
  }
  function validRecord(record, now) {
    return record && record.experiment === config.id && /^[ABC]$/.test(record.variant) &&
      typeof record.subject === 'string' && /^[a-f0-9-]{32,36}$/.test(record.subject) &&
      Number.isFinite(record.firstAt) && record.firstAt <= now && record.firstAt > now - 90 * DAY;
  }
  // The arm to render, decided synchronously so the hero paints without waiting for the
  // consent API. Read-only: enrollment and the stored record still happen in decide(),
  // and only with consent. An unconsented visitor sees an arm but is never counted.
  var early = null;
  // Stable live arm for a browser enrolled in a dropped arm: same subject, same arm on every visit.
  function droppedArmVariant(record) {
    return ARMS[parseInt(record.subject.replace(/-/g, '').slice(-6), 16) % ARMS.length];
  }
  function earlyVariant() {
    if (early) return early;
    early = ARMS[0]; // visitors outside the test see the first live arm
    if (validationVariant) early = validationVariant;
    else if (forced) early = forced;
    else if (!config.preview && !staff && !automated && !query.has('preview_theme_id') && config.enabled) {
      var now = Date.now(), record = null;
      try { record = JSON.parse(window.localStorage.getItem(KEY)); } catch (_) {}
      if (validRecord(record, now)) early = ARMS.indexOf(record.variant) >= 0 ? record.variant : droppedArmVariant(record);
      else if (config.home && config.enroll && now < (config.enrollUntil ? Date.parse(config.enrollUntil) : Infinity)) early = randomVariant();
    }
    return early;
  }
  function decide() {
    state.variant = earlyVariant();
    if (validationVariant) {
      state.reason='validation'; state.variant=validationVariant;
      if(consentAllowed()) {
        state.record={experiment:config.id,variant:validationVariant,subject:subjectId(),firstAt:Date.now()};
        state.eligible=true;
      }
      return;
    }
    if (forced) { state.reason = 'qa_override'; return; }
    if (config.preview) { state.reason = 'preview'; return; }
    if (staff || automated || query.has('preview_theme_id')) { state.reason = 'excluded'; return; }
    if (!config.enabled) { state.reason = 'disabled'; return; }
    if (!consentAllowed()) { state.reason = 'consent_not_allowed'; return; }
    var now = Date.now(), record;
    try {
      try { record = JSON.parse(window.localStorage.getItem(KEY)); } catch (_) { record = null; }
      if (!validRecord(record, now)) {
        var deadline=config.enrollUntil?Date.parse(config.enrollUntil):Infinity;
        if (!config.home || !config.enroll || !(now<deadline)) { state.reason = 'not_enrolled'; return; }
        // Enroll into the arm already on screen (earlyVariant drew it at random).
        record = {experiment:config.id,variant:state.variant,subject:subjectId(),firstAt:now};
        window.localStorage.setItem(KEY, JSON.stringify(record));
        // A stable assignment is required: do not count browsers where storage fails.
        if (JSON.parse(window.localStorage.getItem(KEY)).subject !== record.subject) throw new Error('Storage unavailable');
      }
    } catch (_) { state.reason = 'storage_unavailable'; return; }
    if (ARMS.indexOf(record.variant) < 0) { state.reason = 'arm_dropped'; return; }
    state.variant = record.variant; state.record = record; state.eligible = true; state.reason = 'enrolled';
  }
  function params(extra) {
    return Object.assign({hero_test_id:config.id,hero_variant:state.variant,hero_subject:state.record.subject,hero_first_at:state.record.firstAt,hero_days_since_first:Math.floor((Date.now()-state.record.firstAt)/DAY),transport_type:'beacon'},extra||{});
  }
  function emit(name, extra) {
    if (!state.eligible || consentRevoked || !consentAllowed() || typeof window.gtag !== 'function') return;
    if(validationVariant) extra=Object.assign({debug_mode:true},extra||{});
    window.gtag('event',name,params(extra));
    eventLog.push(name); if (eventLog.length>30) eventLog.shift();
    if (currentSection) currentSection.dataset.heroLastEvent = name;
  }
  function stampCart(clear) {
    if(validationVariant) return;
    if (!clear && (!state.eligible || !consentAllowed())) return;
    var attrs = {
      'pvl_hero_test__': clear ? '' : config.id,
      'pvl_hero_variant__': clear ? '' : state.variant,
      'pvl_hero_subject__': clear ? '' : state.record.subject,
      'pvl_hero_first_at__': clear ? '' : String(state.record.firstAt)
    };
    // Private attributes carry attribution into Shopify orders, including guest checkout.
    // Update attributes only; never touch items, quantities, notes, or checkout navigation.
    // Liquid root_url omits the trailing slash for locales such as /es and /en-gb.
    var cartRoot = (config.cartRoot || '/').replace(/\/+$/, '') + '/';
    window.fetch(cartRoot+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs}),keepalive:true})
      .then(function (r) { if(!r.ok) emit('hero_test_attribution_error',{error_type:'cart_update'}); })
      .catch(function () { emit('hero_test_attribution_error',{error_type:'cart_network'}); });
  }
  function settle() {
    if (settled) return;
    settled = true; decide();
    if (state.eligible) {
      if (typeof window.gtag === 'function') {
        window.gtag('set','user_properties',{hero_test_group:config.id+':'+state.variant});
        window.gtag('set',{hero_test_id:config.id,hero_variant:state.variant});
      }
      if (typeof window.clarity === 'function') window.clarity('set','hero_test_group',config.id+':'+state.variant);
      emit('hero_test_visit');
      stampCart(false);
    }
    readyResolve(state);
  }
  function initializePrivacy(attempt) {
    if (!validationVariant && (forced || config.preview || !config.enabled || staff || automated)) { settle(); return; }
    // Check for the real API: another storefront script creates a stub customerPrivacy object
    // ({serverTimingSupportVerified}) that is truthy long before consent-tracking-api loads.
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') { settle(); return; }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){settle();});
      setTimeout(settle,1500); return;
    }
    if (attempt>=15) { settle(); return; }
    setTimeout(function(){initializePrivacy(attempt+1);},100);
  }
  function flushTime() {
    var now=performance.now();
    if(active) pendingMs+=Math.max(0,now-activeAt);
    activeAt=now;
    if(pendingMs>=1) { var delta=Math.round(pendingMs); pendingMs=0; emit('hero_test_time',{hero_active_ms:delta}); }
  }
  function activityChange() { flushTime(); active=state.eligible&&!document.hidden&&document.hasFocus(); activeAt=performance.now(); }
  function pageHide() { flushTime(); active=false; }
  function loadPlayer(variant) {
    if(players[variant]) return players[variant];
    players[variant]=new Promise(function(resolve,reject){
      var script=document.createElement('script'); script.src=variant==='B'?config.animationScript:config.spinScript;
      script.onload=resolve; script.onerror=reject; document.head.appendChild(script);
    });
    return players[variant];
  }
  function showScene(section,variant) {
    var scene=section.querySelector('[data-hero-scene]');
    scene.replaceChildren(section.querySelector('[data-hero-template="'+variant+'"]').content.cloneNode(true));
    section.dataset.heroRendered=variant;
  }
  function mount(section) {
    if(!section||mounted.has(section)) return;
    mounted.add(section); currentSection=section;
    // Render now; analytics wait for consent below. Media errors before then are queued, not dropped.
    var variant=earlyVariant();
    section.dataset.heroVariant=variant;
    showScene(section,variant);
    var controls=section.querySelector('[data-hero-controls-template="'+variant+'"]');
    if(controls) section.querySelector('[data-hero-controls]').replaceChildren(controls.content.cloneNode(true));
    if(qa) {var badge=section.querySelector('[data-hero-qa]');badge.hidden=false;badge.textContent='Preview '+variant+' · excluded from test';}
    if(variant!=='A') loadPlayer(variant).then(function(){
      if(variant==='B') window.pvlHeroAnimation(section); else window.pvlHeroSpin(section);
    }).catch(function(){showScene(section,'A');section.querySelector('[data-hero-controls]').replaceChildren();ready.then(function(){emit('hero_test_media_error',{error_type:'player_load',hero_rendered_variant:'A'});});});
    section.addEventListener('error',function(event){
      var media=event.target;
      if(media.tagName!=='IMG'&&media.tagName!=='VIDEO') return;
      var details={error_type:media.tagName.toLowerCase()};
      if(media.tagName==='VIDEO') {
        // Capture before fallback/load clears MediaError. No URLs or free-form
        // messages; retain the existing error event and its historical count.
        details.media_error_code=media.error?media.error.code:0;
        details.media_source=media.dataset.spinSource||'unknown';
        details.media_network_state=media.networkState;
        details.media_ready_state=media.readyState;
      }
      ready.then(function(){emit('hero_test_media_error',details);});
    },true);
    section.addEventListener('pvl:spin-recovered',function(event){
      var details={media_source:event.detail.media_source,media_error_code:event.detail.media_error_code};
      ready.then(function(){emit('hero_test_media_recovered',details);});
    });
    section.querySelector('[data-hero-shop]').addEventListener('click',function(){emit('hero_test_shop');flushTime();});
    ready.then(function(){
      section.dataset.heroMode=state.reason;
      section.dataset.heroConsent=consentAllowed()?'allowed':(window.Shopify&&window.Shopify.customerPrivacy&&typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed==='function'?'denied':'unavailable');
      if(validationVariant&&!consentAllowed()&&window.Shopify&&window.Shopify.customerPrivacy) {
        var consentButton=document.createElement('button');
        consentButton.type='button';consentButton.textContent='Allow analytics for this test browser';
        consentButton.addEventListener('click',function(){
          window.Shopify.customerPrivacy.setTrackingConsent({analytics:true},function(){window.location.reload();});
        });
        section.querySelector('[data-hero-qa]').appendChild(consentButton);
      }
      emit('hero_test_exposure',{hero_rendered_variant:state.variant});
      if(state.eligible) {
        activityChange(); timer=setInterval(flushTime,15000);
        document.addEventListener('visibilitychange',activityChange);
        window.addEventListener('focus',activityChange);window.addEventListener('blur',activityChange);
        window.addEventListener('pagehide',pageHide);
        window.addEventListener('pageshow',activityChange);
      }
    });
  }
  document.addEventListener('visitorConsentCollected',function(){
    if(!consentAllowed()&&state.eligible) {
      consentRevoked=true;active=false;clearInterval(timer);
      try { window.localStorage.removeItem(KEY); } catch (_) {}
      if(typeof window.gtag==='function') {
        window.gtag('set','user_properties',{hero_test_group:null});
        window.gtag('set',{hero_test_id:null,hero_variant:null});
      }
      stampCart(true);state.eligible=false;
      if(currentSection) currentSection.dataset.heroMode='consent_revoked';
    }
    // New consent takes effect on the next navigation; never switch treatment mid-view.
  });
  window.pvlHeroExperiment={mount:mount,ready:ready};
  document.dispatchEvent(new CustomEvent('pvl:hero-ready'));
  // This file runs from <head> so the hero can mount the moment it is parsed. Consent is still read
  // after the deferred Shopify scripts (loadFeatures) have run, exactly as when this file was deferred.
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initializePrivacy(0);},{once:true}); else initializePrivacy(0);
})(window, document);
